import img2 from "../../assets/fixyproj.jpeg";
import img4 from "../../assets/atlantidas.png";

const WorkCardData = [
  {
    imgsrc: "/logo-baletti-horizontal.jpg",
    title: "Baletti - AI Catalog Automation",
    text: "AI-powered catalog automation platform for bookstores integrated with Tiendanube. Baletti uses intelligent extraction from barcode and cover scans to auto-complete book metadata, reduce manual workload and accelerate publishing workflows. I led the technical execution as Founding Engineer, designing and building the core product experience from integration to production-ready publishing flows.",
    technologies: [],
    view: "https://www.baletti.app/",
    source: "https://www.baletti.app/",
    role: "Founding Engineer",
    height: "wide",
    featured: false,
    hero: true
  },
  {
    imgsrc: img2,
    title: "Fixy - Task Management",
    text: "Mobile task management application with authentication, task creation/editing, priority management and push notifications.",
    technologies: ["React Native", "Expo", "Firebase", "TypeScript"],
    view: "https://www.linkedin.com/feed/update/urn:li:activity:6965312492080103424/",
    source: "https://www.linkedin.com/feed/update/urn:li:activity:6965312492080103424/",
    height: "short"
  },
  {
    imgsrc: img4,
    title: "Atlántidas Argentinas - Academic Tourism",
    text: "Corporate website for academic tourism company specialized in study abroad programs for international universities. Includes Spanish/English translation system, interactive gallery with filters, contact form with email sending, dynamic sections with animations and SEO-optimized responsive design.",
    technologies: ["Next.js", "TypeScript", "Tailwind CSS", "Framer Motion", "EmailJS", "i18next"],
    view: "http://atlantidasargentinas.com/",
    source: "http://atlantidasargentinas.com/",
    height: "large"
  },
  {
    imgsrc: null,
    title: "More Projects",
    text: "Development of diverse web solutions including e-commerce platforms, corporate websites, mobile applications, AI integrations, intelligent agents, optimized landing pages and advanced technological solutions. All these projects are under confidentiality agreements and cannot be shown publicly.",
    technologies: ["E-commerce", "Web Apps", "Mobile Apps", "Agent"],
    view: "#contact",
    source: "#contact",
    height: "medium",
    isDescriptive: true
  },
];

export default WorkCardData;
